export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/array.js
// module id = ./node_modules/d3-axis/src/array.js
// module chunks = 54